var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.label
      ? _c("label", { staticClass: "form-label" }, [_vm._v(_vm._s(_vm.label))])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { ref: "colorpicker", staticClass: "input-group color-picker flex" },
      [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.colorValue,
              expression: "colorValue"
            }
          ],
          staticClass: "color-input",
          class: { "block-not-valid": !_vm.isValidHexColor },
          attrs: { disabled: _vm.disabled, placeholder: "Pick colour" },
          domProps: { value: _vm.colorValue },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.colorValue = $event.target.value
            }
          }
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "color-picker-container" },
          [
            _c("b-form-input", {
              attrs: { type: "color" },
              model: {
                value: _vm.colorValue,
                callback: function($$v) {
                  _vm.colorValue = $$v
                },
                expression: "colorValue"
              }
            })
          ],
          1
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "span",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.isValidHexColor,
            expression: "!isValidHexColor"
          }
        ],
        staticClass: "font-not-valid"
      },
      [_vm._v("Hex Color Code Not Valid")]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0bc3069e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0bc3069e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/color-picker/jColorPicker.vue
// module id = null
// module chunks = 